import { TStudentAssessmentRecord } from '../../../apis/students/studentDetails/studentDetails.interfaces';

const getGrade = (percentage: number): string => {
  if (percentage >= 90) return 'A+';
  if (percentage >= 80) return 'A';
  if (percentage >= 70) return 'B+';
  if (percentage >= 60) return 'B';
  if (percentage >= 50) return 'C+';
  if (percentage >= 40) return 'C';
  if (percentage >= 30) return 'D';
  return 'F';
};

export const mockStudentDetailsAssessments: TStudentAssessmentRecord[] = [
  {
    id: 'assess-1',
    subject: 'Mathematics',
    title: 'Algebra Test',
    score: 85,
    maxScore: 100,
    grade: getGrade(85),
    date: '2024-01-15',
  },
  {
    id: 'assess-2',
    subject: 'Science',
    title: 'Physics Quiz',
    score: 92,
    maxScore: 100,
    grade: getGrade(92),
    date: '2024-01-20',
  },
  {
    id: 'assess-3',
    subject: 'English',
    title: 'Grammar Test',
    score: 78,
    maxScore: 100,
    grade: getGrade(78),
    date: '2024-01-25',
  },
  {
    id: 'assess-4',
    subject: 'Mathematics',
    title: 'Geometry Exam',
    score: 88,
    maxScore: 100,
    grade: getGrade(88),
    date: '2024-02-01',
  },
  {
    id: 'assess-5',
    subject: 'Science',
    title: 'Chemistry Test',
    score: 75,
    maxScore: 100,
    grade: getGrade(75),
    date: '2024-02-05',
  },
  {
    id: 'assess-6',
    subject: 'English',
    title: 'Literature Essay',
    score: 82,
    maxScore: 100,
    grade: getGrade(82),
    date: '2024-02-10',
  },
  {
    id: 'assess-7',
    subject: 'Mathematics',
    title: 'Calculus Test',
    score: 90,
    maxScore: 100,
    grade: getGrade(90),
    date: '2024-02-15',
  },
  {
    id: 'assess-8',
    subject: 'Science',
    title: 'Biology Quiz',
    score: 88,
    maxScore: 100,
    grade: getGrade(88),
    date: '2024-02-20',
  },
];
